import { useCurrentModule } from '../../ModuleProvider';
export const ECLIPSE_CHECKOUT_SKELETON_SPEC = 'eclipseCheckoutSkeleton';
export const useIsCheckoutSkeleton = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  return experiments.isEnabled(ECLIPSE_CHECKOUT_SKELETON_SPEC);
};
//# sourceMappingURL=useIsCheckoutSkeleton.js.map